import axios, { AxiosInstance } from 'axios';
import { apiUrl, hash } from '../config';

class Api {
  public api: AxiosInstance;

  constructor() {
    const token = localStorage.getItem(`@${hash}:token`);

    this.api = axios.create({
      baseURL: apiUrl,
    });

    if (token) {
      this.api.defaults.headers.Authorization = `Bearer ${token}`;
    }
  }
}

export default new Api().api;
